







































































































import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter, namespace } from "vuex-class";

import AvailabilityBanner from "@/components/mobile/core/AvailabilityBanner.vue";
import UnavailablePicker from "@/components/mobile/core/UnavailablePicker.vue";
import { Guard, GuardStatus, LeftSidebar, MobileFeatures } from "@/store/mobile/types";
import CoverPicker from "@/components/mobile/core/CoverPicker.vue";
import CoverRequest from "@/components/mobile/core/CoverRequest.vue";

const Mobile = namespace("mobile");

@Component({
	components: {
		"cover-request": CoverRequest,
		"availability-banner": AvailabilityBanner,
		"unavailable-picker": UnavailablePicker,
		"cover-picker": CoverPicker
	}
})
export default class LeftSideBar extends Vue {
	@Getter getFeature: (featureName: string[]) => boolean;
	@Mobile.State CoverCallSign: Guard;
	@Mobile.State LeftSidebar: LeftSidebar;
	@Mobile.State(state => state.DispatchGuard.statusEnum) status: GuardStatus;
	@Mobile.Getter("getCoverButtonDisabled") coverButtonDisabled: boolean;
	@Mobile.Action loadCoverRequest: () => Promise<void>;
	@Mobile.Mutation("setUnavailablePickerShown") setUnavailablePicker: (shown: boolean) => void;
	@Mobile.Mutation("setCoverPickerShown") setCoverPicker: (shown: boolean) => void;
	@Mobile.Action cancelCover: () => Promise<void>;

	@Mobile.Getter("getCallSign") callSign: "";
	@Mobile.Getter("getIsCoverAvailable") isCoverAvailable: boolean;
	@Mobile.Mutation setCoverAvailability: any;
	@Mobile.Getter("getOnDuty") onDuty: boolean;
	@Mobile.Mutation setOnDuty: any;
	@Mobile.Getter("getMobileFeatures") getMobileFeatures: MobileFeatures;
	@Mobile.Mutation setShowDirections: any;
	@Mobile.Getter("getIsRightSidebarOpen") isRightSidebarOpen: boolean;
	@Mobile.Getter("getIsLeftSidebarOpen") isLeftSidebarOpen: boolean;
	@Mobile.Mutation toggleLeftSidebarVisibility: () => void;
	@Mobile.Action loadGuardForUser: () => Promise<void>;
	@Mobile.Action loadCoverCallSigns: () => Promise<void>;
	@Mobile.State(state => state.DispatchGuard.originalCallSign) originalCallSign: string;

	public showLogoutModal: boolean = false;
	public showBreakCard: boolean = false;
	public directionsToggle: boolean = true;

	@Prop(Boolean)
	public openLeftSidebar: boolean;

	public get isMobileCoverEnabled(): boolean {
		return this.getFeature(["Mobile", "GuardCovering"]);
	}

	private get coverRequested(): boolean {
		return this.status == GuardStatus.CoveringRequested;
	}

	private get covering(): boolean {
		return Boolean(this.originalCallSign) || this.status == GuardStatus.Covering;
	}

	private get ableToLogout(): boolean {
		//Disable logout when covering in any way.
		return !(this.covering || this.status == GuardStatus.CoveringRequested);
	}

	@Watch("openLeftSidebar")
	private async onLeftSideBarChanged() {
		await this.loadGuardForUser();
		// Load guards which can be covered and any cover requests
		await this.loadCoverCallSigns();
		await this.loadCoverRequest();

		// Hide cover/unavailable picker
		this.setUnavailablePicker(false);
		this.setCoverPicker(false);

		// Show the sidebar
		this.toggleLeftSidebarVisibility();
	}

	@Watch("directionsToggle")
	private onDirectionsToggleChanged(value: boolean, oldValue: boolean) {
		this.setShowDirections(value);
	}

	@Emit("logout")
	private logout() {
	}

	public get callSignSelected(): boolean {
		if (typeof this.callSign !== "undefined" && this.callSign !== "") {
			return true;
		} else {
			return false;
		}
	}

	private get showRightSidebar(): boolean {
		return this.isRightSidebarOpen && !this.isLeftSidebarOpen;
	}

	private get showLeftSidebar(): boolean {
		return this.isLeftSidebarOpen && !this.isRightSidebarOpen;
	}
}
